import assetActions from '../../../actions/assetActions';
import assetTableColumns, {
  assetTableLeftFixedColumns,
} from './assetTableColumns';
import generateEntityTable from '../../../hocs/generateEntityTable';

const AssetsTable = generateEntityTable({
  entityPluralString: 'assets',
  entityActions: assetActions,
  columns: assetTableColumns,
  leftFixedColumns: assetTableLeftFixedColumns,
  operations: [],
});

export default AssetsTable;